var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBifi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.47 6.828H2l.244 1.589c.118.766.632 2.526 1.906 3.8a10.133 10.133 0 0 0 1.94 1.523v11.703l.102.25C6.985 27.638 9.98 30 15.608 30c5.595 0 8.1-2.408 8.272-4.726l.004-.05v-10.81c.55-.413 1.891-1.458 2.63-2.197.498-.498.924-1.245 1.227-1.84.324-.636.592-1.277.745-1.686l.7-1.862h-6.13v-2.63l-.049-.136a3.386 3.386 0 0 0-.865-1.274 2.886 2.886 0 0 0-3.962 0 3.386 3.386 0 0 0-.865 1.274l-.05.137v2.628h-4v-2.63l-.05-.136a3.386 3.386 0 0 0-.865-1.274 2.886 2.886 0 0 0-3.964 0 3.385 3.385 0 0 0-.864 1.274l-.05.137v2.628zm4.138 0V4.514c-.073-.146-.2-.341-.382-.51a1.233 1.233 0 0 0-.86-.349c-.357 0-.636.143-.86.35-.181.168-.309.363-.38.509v2.314h2.482zm9.793 0V4.514c-.071-.146-.199-.341-.381-.51a1.233 1.233 0 0 0-.86-.349c-.358 0-.636.143-.86.35-.182.168-.31.363-.382.509v2.314h2.483zM6.1 10.266a3.517 3.517 0 0 1-.52-.68h8.112c-.116 2.336.113 5.892 1.64 8.138 2.09 3.075 4.511 4.724 5.793 5.045v2.327c-.054.288-.71 2.144-5.517 2.144-4.5.001-6.298-1.683-6.759-2.4v-12.9l-.896-.335c-.17-.064-.99-.475-1.854-1.339zm6.75 6.906a1.24 1.24 0 1 1-2.484 0 1.24 1.24 0 0 1 2.483 0zm7.723 0a1.24 1.24 0 1 1-2.483 0 1.24 1.24 0 0 1 2.483 0z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBifi);
export default __webpack_public_path__ + "static/media/BIFI.5b234624e7e538b41a9fa8a91b0514df.svg";
export { ForwardRef as ReactComponent };